// Generated types for ModelRequest
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ScopedNodeReadAPI, ScopedNodeWriteAPI } from '../../shared/types/scopednode';
import { ScopedNodeReadAPISchemaObject, ScopedNodeWriteAPISchemaObject } from '../../shared/types/scopednode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ModelRequestReadAPI extends Omit<ScopedNodeReadAPI, 'created_at'> {
  /** When request was created */
  created_at?: string | null;
  /** Name of the agent that processed this request */
  agent_name?: string | null;
  /** Model used for this request */
  model_name?: string | null;
  /** The 1st user prompt sent to the model */
  user_prompt?: string | null;
  /** Order within the Step */
  order_index?: number;
}

export interface ModelRequestWriteAPI extends ScopedNodeWriteAPI {
  /** Name of the agent that processed this request */
  agent_name?: string | null;
  /** Model used for this request */
  model_name?: string | null;
  /** The 1st user prompt sent to the model */
  user_prompt?: string | null;
  /** Order within the Step */
  order_index?: number;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ModelRequestReadAPISchema: z.ZodType<ModelRequestReadAPI> = ScopedNodeReadAPISchemaObject.omit({ 'created_at': true }).extend({
  created_at: z.string().nullable().optional(),
  agent_name: z.string().nullable().optional(),
  model_name: z.string().nullable().optional(),
  user_prompt: z.string().nullable().optional(),
  order_index: z.number().optional(),
}).passthrough();

export const ModelRequestWriteAPISchema: z.ZodType<ModelRequestWriteAPI> = ScopedNodeWriteAPISchemaObject.extend({
  agent_name: z.string().nullable().optional(),
  model_name: z.string().nullable().optional(),
  user_prompt: z.string().nullable().optional(),
  order_index: z.number().optional(),
}).passthrough();
